import { render, staticRenderFns } from "./SameArticlesDialog.vue?vue&type=template&id=736bd25e&scoped=true"
import script from "./SameArticlesDialog.vue?vue&type=script&lang=ts"
export * from "./SameArticlesDialog.vue?vue&type=script&lang=ts"
import style0 from "./SameArticlesDialog.vue?vue&type=style&index=0&id=736bd25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bd25e",
  null
  
)

export default component.exports